import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const AnonymousSignUpFooter = /*#__PURE__*/ memo((param)=>{
    let { children, className, onFullLoginClick, onCancelClick } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("flex items-center justify-between", className),
        children: [
            /*#__PURE__*/ _jsxs("p", {
                className: "text-12 text-pigeon-500",
                children: [
                    "Already on Air?",
                    " ",
                    /*#__PURE__*/ _jsx("button", {
                        "data-testid": "ANONYMOUS_SIGNUP_FORM_FULL_LOGIN_BUTTON",
                        type: "button",
                        className: "font-semibold text-jay-600 hover:underline",
                        onClick: onFullLoginClick,
                        children: "Log In"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-3",
                children: [
                    onCancelClick && /*#__PURE__*/ _jsx(Button, {
                        onClick: onCancelClick,
                        appearance: "ghost",
                        color: "grey",
                        size: "large",
                        children: "Cancel"
                    }),
                    children
                ]
            })
        ]
    });
});
AnonymousSignUpFooter.displayName = "AnonymousSignUpFooter";
